var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-editor',{attrs:{"permission":"news","publication":true,"fields":_vm.fields,"updatePossible":true,"endpoint":"news","previewModule":"actueel","module":"news"},on:{"update":_vm.updateState}})
}
var staticRenderFns = []

export { render, staticRenderFns }